module.exports = __webpack_public_path__ + "static/media/official.368e614.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/serie_a/official.mp4
// module id = cTZU
// module chunks = 1